import { gql, useMutation } from '@apollo/client';
import { AUDIT_CHAT_FIELDS, AuditChat } from './useAuditChatQuery';

export const INITIATE_AUDIT_CHAT_MUTATION = gql`
  ${AUDIT_CHAT_FIELDS}
  mutation InitiateAuditChat($applicationId: String!) {
    initiateAuditChat(applicationId: $applicationId) {
      ...AuditChatFields
    }
  }
`;

interface InitiateAuditChatMutationResult {
  initiateAuditChat: AuditChat;
}

export interface InitiateAuditChatMutationVariables {
  applicationId: string;
}

export const useInitiateAuditChatMutation = () => {
  return useMutation<InitiateAuditChatMutationResult, InitiateAuditChatMutationVariables>(
    INITIATE_AUDIT_CHAT_MUTATION,
    {
      refetchQueries: ['GetUser'],
    }
  );
};
